export const safeString = (v: any): string =>
    typeof v === "string" ? v : v == null ? "" : String(v);

/**
 * Унифицированные пикеры под оба ответа:
 * - /admin/subscribed-users: subscription.expiresAt | subscription.expires_at, plan может быть объектом/строкой
 * - /admin/users: subscription.plan (строка), subscription.expires_at
 */
export const pickPlanCode = (u: any): string =>
    safeString(
        u?._ui?.planCode ||
        u?.subscription?.plan?.code ||
        u?.subscription?.plan || // строка из /admin/users
        u?.subscription?.code ||
        "",
    );

export const pickExpiresAt = (u: any): string | null =>
    (u?._ui?.expiresAt ??
        u?.subscription?.expiresAt ??
        u?.subscription?.expires_at ??
        null) as string | null;

export const pickCreatedAt = (u: any): string | null =>
    (u?.createdAt ?? u?.created_at ?? null) as string | null;

export const pickListingsCount = (u: any): number | null => {
    const rawValue =
        u?._ui?.listingsCount ??
        u?.listings_count ??
        u?.listingsCount ??
        u?.classifieds_count ??
        u?.classifiedsCount ??
        u?.advertisements_count ??
        u?.ads_count ??
        u?.listings?.count ??
        null;
    const count = Number(rawValue);

    return Number.isFinite(count) && count >= 0 ? count : null;
};

export type StatusTone = "ok" | "warn" | "danger" | "none";

export const getStatusTone = (daysLeft: number | null, expiringDays = 7): StatusTone => {
    if (typeof daysLeft !== "number") return "none";
    if (daysLeft < 0) return "danger";
    if (daysLeft <= expiringDays) return "warn";
    return "ok";
};
